module.exports = __webpack_public_path__ + "img/round4.3752c218.png";